import type { FC, PointerEvent, ReactNode } from 'react'

import { useRef } from 'react'
import { cn } from '@/lib/utils'

interface TiltProps {
    children: ReactNode
    max?: number
    className?: string
}

// Leans its content toward the mouse. Touch devices are left alone.
export const Tilt: FC<TiltProps> = ({ children, max = 8, className }): ReactNode => {
    const ref = useRef<HTMLDivElement>(null)

    const onMove = (event: PointerEvent<HTMLDivElement>): void => {
        const node = ref.current
        if (!node || event.pointerType !== 'mouse') return

        const rect = node.getBoundingClientRect()
        const x = (event.clientX - rect.left) / rect.width - 0.5
        const y = (event.clientY - rect.top) / rect.height - 0.5

        node.classList.add('is-tilting')
        node.style.setProperty('--tilt-x', `${(-y * max).toFixed(2)}deg`)
        node.style.setProperty('--tilt-y', `${(x * max).toFixed(2)}deg`)
    }

    const onLeave = (): void => {
        const node = ref.current
        if (!node) return

        node.classList.remove('is-tilting')
        node.style.setProperty('--tilt-x', '0deg')
        node.style.setProperty('--tilt-y', '0deg')
    }

    return (
        <div ref={ref} onPointerMove={onMove} onPointerLeave={onLeave} className={cn('tilt', className)}>
            {children}
        </div>
    )
}
